import { useContextSelector } from 'use-context-selector';
import { MenuItemsContextValues } from '@app/types/core/menu-items';
import { MenuItemsContext } from '@shared/contexts/MenuItemsContext';

/**
 * @description Hook to select specific values from MenuItemsContext.
 * Only components using selected values will re-render when those values change.
 * @example
 * const items = useMenuItemsSelector(state => state.items);
 * const revalidate = useMenuItemsSelector(state => state.revalidate);
 */
export const useMenuItemsSelector = <T>(
  selector: (value: MenuItemsContextValues) => T
): T => {
  return useContextSelector(MenuItemsContext, (value) => {
    if (!value) {
      throw new Error('context must be use inside provider');
    }
    return selector(value);
  });
};

/**
 * @description Legacy hook for backward compatibility.
 * @deprecated Use useMenuItemsSelector instead for better performance.
 * This hook causes all components to re-render when any context value changes.
 */
const useMenuItems = (): MenuItemsContextValues => {
  return useContextSelector(MenuItemsContext, (value) => {
    if (!value) {
      throw new Error('context must be use inside provider');
    }
    return value;
  });
};

export default useMenuItems;
